module.exports = __webpack_public_path__ + "static/img/scidrive.d123c27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scidrive.png
// module id = Fs7G
// module chunks = 1